import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false,
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, length: number): string {
        return value.substr(0, length) + (value.length > length ? '...' : '');
    }
}
